import barba from '@barba/core';
import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSVideoCardTagName: string = 'hhds-video-card';
const TAG_NAME: string = HHDSVideoCardTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSVideoCardAttrNames = {
	href: 'href',
};

const Attrs = HHDSVideoCardAttrNames;

export class HHDSVideoCard extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = `
      <div class="${TAG_NAME}">
				<div class="${TAG_NAME}__image-area">
					<div class="${TAG_NAME}__play-button">
						<svg class="play-icon" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
							<rect class="bg" width="80" height="80" rx="40" />
							<path class="triangle" d="M54 40.0006C54.0008 40.3402 53.9138 40.6741 53.7473 40.9701C53.5808 41.266 53.3406 41.5138 53.05 41.6894L35.04 52.7069C34.7364 52.8928 34.3886 52.9943 34.0326 53.0009C33.6766 53.0075 33.3253 52.9189 33.015 52.7444C32.7076 52.5725 32.4516 52.3219 32.2732 52.0183C32.0948 51.7147 32.0005 51.369 32 51.0169V28.9844C32.0005 28.6322 32.0948 28.2866 32.2732 27.983C32.4516 27.6793 32.7076 27.4287 33.015 27.2569C33.3253 27.0823 33.6766 26.9938 34.0326 27.0003C34.3886 27.0069 34.7364 27.1084 35.04 27.2944L53.05 38.3119C53.3406 38.4875 53.5808 38.7353 53.7473 39.0312C53.9138 39.3271 54.0008 39.6611 54 40.0006Z"/>
						</svg>
					</div>
					<slot name="image"></slot>
				</div>
				<slot name="header"></slot>
				<slot name="body"></slot>
			</div>
    `;

		this.setInnerHtml('', '', html);

		const href = this.vars.get<string>(Attrs.href);
		if (href?.length) {
			//const focusTarget = this.element(`.${TAG_NAME}__image-area`);
			const focusTarget = this.element(`.${TAG_NAME}__play-button`);
			if (focusTarget) {
				// find any header element inside the header slot
				const header = this.element(`[slot="header"]`);
				let ariaLabel: string = 'Go to video page';
				if (header) {
					ariaLabel = 'Go to video page for ' + (header.textContent?.trim() || '');
				}

				focusTarget.setAttribute('role', 'button');
				focusTarget.setAttribute('tabindex', '0');
				focusTarget.setAttribute('aria-label', ariaLabel);
				focusTarget.addEventListener('keydown', (event: KeyboardEvent) => {
					if (event.key === 'Enter' || event.key === ' ') {
						event.preventDefault();
						focusTarget.click();
					}
				});
				focusTarget.addEventListener('click', () => {
					barba.go(href);
				});
			}
		}

		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	[Attrs.href]: {
		description: 'The URL to navigate to when the card is clicked.',
		type: String,
		defaultValue: '',
	},
};
